import React from "react";

const PageHeader = ({ fullName, range }) => (
  <header className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-3">
    <div>
      <p className="text-[11px] font-bold uppercase tracking-widest text-gray-400">
        Driver Detail
      </p>
      <h1 className="text-3xl font-bold tracking-tight leading-tight text-gray-900">
        {fullName} <span className="text-gray-400 font-medium">— Weekly Report</span>
      </h1>
    </div>
    <div className="px-4 py-2 border border-gray-200 rounded-lg text-xs font-medium text-gray-600 bg-white shadow-sm">
      <span className="text-gray-400 uppercase tracking-wider text-[10px] mr-2">
        Week
      </span>
      {range.from || "—"} <span className="mx-1 text-gray-400">→</span> {range.to || "—"}
    </div>
  </header>
);

export default PageHeader;
